"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PinWebCircle = void 0;
var React = __importStar(require("react"));
var PinWebCircle = function (_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M41.85,9.49c-0.86-1.05-1.8-2.02-2.83-2.91C34.99,3.11,29.74,1,24,1S13.01,3.11,8.98,6.59C7.96,7.47,7.01,8.44,6.15,9.49\n      C2.93,13.45,1,18.5,1,24c0,5.5,1.93,10.54,5.15,14.5c0.86,1.05,1.8,2.02,2.83,2.91C13.01,44.89,18.26,47,24,47\n      c5.74,0,10.99-2.11,15.02-5.59c1.03-0.89,1.97-1.86,2.83-2.91C45.07,34.54,47,29.5,47,24C47,18.5,45.07,13.45,41.85,9.49z\n      M42.88,22h-7.06c-0.37-2.22-1.35-4.24-2.77-5.87c2.18-0.94,4.19-2.2,5.97-3.73C41.12,15.12,42.5,18.41,42.88,22z M16,24\n      c0-0.69,0.1-1.36,0.26-2c0.48-1.84,1.59-3.43,3.1-4.5C20.67,16.56,22.27,16,24,16s3.33,0.56,4.64,1.5c1.51,1.08,2.62,2.66,3.1,4.5\n      C31.9,22.64,32,23.31,32,24c0,0.61-0.14,1.29-0.37,2c-0.47,1.42-1.37,3-2.49,4.6c-0.85,1.2-1.82,2.41-2.84,3.56\n      c-0.1,0.11-0.2,0.23-0.3,0.34c-0.66,0.73-1.33,1.43-2,2.09c-0.67-0.66-1.34-1.36-2-2.09c-0.1-0.11-0.2-0.23-0.3-0.34\n      c-1.02-1.15-1.99-2.36-2.84-3.56c-1.12-1.6-2.01-3.18-2.49-4.6C16.14,25.29,16,24.61,16,24z M26,5.12\n      c3.88,0.41,7.41,1.99,10.24,4.38c-2.01,1.7-4.39,2.98-6.99,3.73c-1.02-0.5-2.11-0.85-3.26-1.05V5.12z M22,5.12v7.06\n      c-1.15,0.19-2.24,0.55-3.26,1.05c-2.6-0.75-4.97-2.03-6.99-3.73C14.59,7.1,18.12,5.53,22,5.12z M8.98,12.4\n      c1.77,1.53,3.78,2.79,5.97,3.73c-1.42,1.63-2.4,3.64-2.77,5.87H5.12C5.5,18.41,6.88,15.12,8.98,12.4z M5.12,26h7.12\n      c0.43,1.96,1.42,3.97,2.66,5.88c-2.16,0.93-4.15,2.19-5.91,3.71C6.88,32.88,5.5,29.59,5.12,26z M22,42.88\n      c-3.88-0.41-7.42-1.99-10.25-4.38c1.65-1.4,3.54-2.5,5.6-3.28c1.65,2.02,3.37,3.76,4.65,4.97V42.88z M26,42.88v-2.69\n      c1.28-1.21,2.99-2.95,4.65-4.97c2.06,0.77,3.95,1.88,5.6,3.28C33.42,40.9,29.88,42.47,26,42.88z M39.02,35.59\n      c-1.76-1.52-3.75-2.77-5.91-3.71c1.24-1.91,2.23-3.93,2.66-5.88h7.12C42.5,29.59,41.12,32.88,39.02,35.59z"
  }), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "3"
  })));
};
exports.PinWebCircle = PinWebCircle;